import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HttpModule } from '@angular/http';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { Ng5SliderModule } from 'ng5-slider';

import { rootReducer, metaReducers } from './app.reducers';
import * as logic from './logics';
import { STORE_DEV_TOOLS } from './constants';

export const APP_IMPORTS = [
    BrowserModule,
    BrowserAnimationsModule,
    Ng5SliderModule,
    HttpModule,
    metaReducers ?
      StoreModule.forRoot(rootReducer, { metaReducers }) :
      StoreModule.forRoot(rootReducer),
    EffectsModule.forRoot([
      ...Object.keys(logic)
      .filter(key =>
        key.substr(-7) === 'Effects')
      .map(key => logic[key])
    ]),
    StoreDevtoolsModule.instrument({
      logOnly: STORE_DEV_TOOLS !== 'monitor'
    })
];



// WEBPACK FOOTER //
// ./src/app/app.imports.ts